import React, { Fragment, useState } from 'react';
import DropZone from '../common/DropZone';
import styled from '@emotion/styled';

const Wrapper = styled('div')`
  .dropzone {
    display: flex;
    align-items: center;
    padding: 5px;
    min-height: 48px;
    cursor: pointer;
    background-color: #ffffff;
    border: 2px dashed rgba(50, 58, 70, 0.3);

    &.with-text {
      width: 100%;
    }

    .fe-upload {
      display: none;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
      transition-duration: 0.3s;
    }
  }

  .selected-file {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 10px;

    .selected-file-name {
      font-weight: bold;
    }

    .selected-file-delete {
      display: none;
      height: 20px;
      width: 20px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }

    &:hover {
      background-color: #f2f6f9;

      .selected-file-delete {
        display: flex;
      }
    }
  }
`;

const UploadFiles = (props) => {
  const { files, setFiles, isSingle, accept, maxSize } = props;

  const handleSelectFiles = (newFiles) => {
    if (newFiles && newFiles.length) {
      setFiles([...files, ...newFiles]);
    }
  };

  const handleUnbindFile = (idx) => {
    setFiles([...files.slice(0, idx), ...files.slice(idx + 1)]);
  };

  return (
    <Wrapper>
      {files
        ? files.map((file, idx) => (
            <div className="selected-file" key={idx} data-testid="selected-file">
              <div className="selected-file-name" data-testid="selected-file-name">
                <i className="fe-paperclip mr-1" />
                {file.name}
              </div>
              <div className="selected-file-delete" onClick={() => handleUnbindFile(idx)}>
                <i className="fe-trash-2" data-testid={`trash-${idx}`} />
              </div>
            </div>
          ))
        : null}

      <DropZone
        handleFileDrop={handleSelectFiles}
        showDescription={true}
        dropzoneDescription={'Перетащите сюда файлы или кликните для их выбора'}
        isSingle={isSingle}
        accept={accept}
        maxSize={maxSize}
      />
    </Wrapper>
  );
};

export default UploadFiles;
